var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCaretLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3536 2.64645C10.5488 2.84171 10.5488 3.15829 10.3536 3.35355L5.70711 8L10.3536 12.6464C10.5488 12.8417 10.5488 13.1583 10.3536 13.3536C10.1583 13.5488 9.84171 13.5488 9.64645 13.3536L4.64645 8.35355C4.45118 8.15829 4.45118 7.84171 4.64645 7.64645L9.64645 2.64645C9.84171 2.45118 10.1583 2.45118 10.3536 2.64645Z",
    fill: "#22264C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCaretLeft);
export default __webpack_public_path__ + "static/media/ic_caret_left.7b2ff202.svg";
export { ForwardRef as ReactComponent };